module.exports = __webpack_public_path__ + "static/img/3.8b067da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main-view/3.jpg
// module id = kJGS
// module chunks = 1